export default __webpack_public_path__ + "static/media/IQLaptop.89f5b254.png";